import {
  HttpEvent,
  HttpRequest,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { CookieService } from '@app/core/services/cookie/cookie.service';
import { inject } from '@angular/core';

export const apiPrefixInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {

  const cookieService: CookieService = inject(CookieService, { optional: true })!;

  const jwtFlowEnabled: boolean = cookieService?.getCookie('jwt_flow') === 'true';

  const baseApiUrl: string =
    jwtFlowEnabled && environment?.apiGatewayUrl
      ? environment?.apiGatewayUrl
      : environment?.apiUrl;

  const apiRouteMap: Record<string, string> = {
    '/api/users': environment.usersApiUrl,
    '/api/users/credit': environment.creditServiceUrl,
    // '/api/checkout': environment.checkoutApiUrl,
  };

  let apiUrl: string = baseApiUrl;

  // if (!environment.staging) {
  //   const matchedRoute = Object.keys(apiRouteMap).find((route) =>
  //     req.url.includes(route),
  //   );
  //   if (matchedRoute) {
  //     apiUrl = apiRouteMap[matchedRoute];
  //   }
  // }
  // if (!environment.staging) {
  const matchedRoute = Object.keys(apiRouteMap)
    .sort((a, b) => b.length - a.length) // 🔥 important
    .find((route) => req.url.startsWith(route));

  if (matchedRoute && !jwtFlowEnabled) {
    apiUrl = apiRouteMap[matchedRoute];
  }
  // }

  // if (environment.staging) {
  //   // console.log("host:", HOST);
  //   // const subdomain = env.subdomain;
  //   const subdomain = "staging-api";
  //   apiUrl = StringUtils.format(apiUrl, subdomain);
  // }
  if (!/^(http|https):/i.test(req.url)) {
    req = req.clone({ url: apiUrl + req.url });
  }

  return next(req);
};
